export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/11a14d9b63ec892bb84cea8c67204259.svg";